import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth.service';
import {AnalyticsService} from '../analytics.service';
import { environment } from '../../environments/environment';
import * as Sentry from '@sentry/browser';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {

  public loadingComplete = false;

  constructor(public auth: AuthService, public analytics: AnalyticsService) {
    auth.handleAuthentication();
    auth.scheduleRenewal();

  }

  ngOnInit() {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      this.auth.renewTokens();

      this.auth.waitForAuthReady().then(() => {
        this.loadingComplete = true;
      });
    } else {
      this.loadingComplete = true;
    }

    this.auth.waitForUserProfile(1000).then(
      (user) => {
        this.analytics.sendUserInfo(user['email']);

        if (user['email'] !== 'anonymous@unknown.org') {

          // @ts-ignore
          const opts = window._sva = window._sva || {};

          opts.traits = {
              'user_id': user['sub'],
              'email': user['email']
          };

        }

        this.auth.getUser()
          .pipe(take(1))
          .subscribe({
            next: (platformUser) => {
              // @ts-ignore
              window.Intercom('boot', {
                app_id: 'rz1hwc7q',
                email: user['email'],
                user_id: user['sub'],
                name: user['given_name'] + ' ' + user['family_name'],
                user_hash: platformUser.emailHash
              });
            },
            error: (error) => {
              console.error('Got error from user profile fetching', error);

              // @ts-ignore
              window.Intercom('boot', {
                app_id: 'rz1hwc7q',
              });
            }
          });


        Sentry.configureScope(scope => {
          scope.setUser({
            id: user['sub'],
            email: user['email'],
          });
        });


      }
    );

  }


}
